<template>
    <MainHeader/>
    <div class="content">
        <VerticalBarGrT/>
        <div class="container">
            <!-- <div class="grsection">
                <h1>Estime de soi</h1>
                <img src="@/assets/illustration/eds.webp" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                            Le groupe thérapeutique "Estime de soi" s'adresse aux personnes souffrant d'une baisse d'estime de soi.
                            Il propose des outils pour restaurer l'estime de soi, renforcer la confiance en soi, cultiver l'amour de soi et développer la capacité à s'affirmer. 
                            Les participants sont invités à participer activement aux séances et à effectuer des exercices à la maison. 
                            Le groupe inclut des notions théoriques et des exercices spécifiques visant à atteindre des objectifs tels que l'identification des joies de la vie quotidienne, l'écoute de ses besoins et la reconnaissance de ses qualités.
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i> Rue du marché 4 / 2300 La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> 4 à 6 personnes</p>
                        <p><i class="material-icons">calendar_view_month</i> 30 séances</p>
                        <p><i class="material-icons">phone</i> 079 235 54 26 </p>
                    </div>
                </div>
            </div>
            <div class="grsection">
                <h1>Gestion des émotions</h1>
                <img src="@/assets/illustration/gde.png" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                        Le groupe thérapeutique "Gestion des émotions" est destiné aux personnes ayant des difficultés à 
                        réguler leurs émotions et souhaitant améliorer la gestion de celles-ci. Il propose des outils pour mieux comprendre 
                        et gérer ses émotions, avec une participation active requise durant les séances et à la maison. Il comporte des notions 
                        théoriques et des exercices pour développer des compétences de gestion des émotions, ainsi que des informations, vidéos, 
                        témoignages et une séance de relaxation guidée
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i> Rue du marché 4 / 2300 La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> 4 à 6 personnes</p>
                        <p><i class="material-icons">calendar_view_month</i> 20 séances</p>
                        <p><i class="material-icons">phone</i> 079 235 54 26 </p>
                    </div>
                </div>
            </div>
            <div class="grsection">
                <h1>Education Thérapeutique</h1>
                <img src="@/assets/illustration/et.png" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                        Le groupe thérapeutique "Education Thérapeutique" est destiné aux personnes souhaitant améliorer leur compréhension de 
                        leur maladie et de leurs traitements, ainsi que leur qualité de vie. Il propose des exercices pour devenir plus acteur 
                        de sa prise en charge, comprendre son corps et sa maladie, repérer les signes d'alerte, gérer la maladie et son quotidien, 
                        utiliser les ressources du système de soin et faire valoir ses droits. Les participants sont invités à participer activement 
                        aux séances et à réaliser un plan de crise conjoint
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i> Rue du marché 4 / 2300 La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> 4 à 6 personnes</p>
                        <p><i class="material-icons">calendar_view_month</i> 7 séances</p>
                        <p><i class="material-icons">phone</i> 079 235 54 26 </p>
                    </div>
                </div>
            </div> -->
            <div class="grsection">
                <h1>La mindfulness</h1>
                <img src="@/assets/illustration/IMG-20251023-WA0006.jpg" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                        La mindfulness en groupe est une pratique de pleine conscience réalisée collectivement, favorisant la concentration, la détente et la connexion aux autres. À travers des exercices de respiration, de méditation ou d’écoute active, elle permet de cultiver la présence à l’instant présent tout en renforçant le sentiment d’appartenance et d’empathie. Pratiquée en groupe, elle encourage le partage d’expériences et crée un environnement bienveillant propice au bien-être mental et émotionnel
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i>Neuchâtel et La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> Jusqu'à 15 personnes</p>
                        <p><i class="material-icons">phone</i> 076 287 33 36 </p>
                        <p><i class="material-icons">event_available</i>Chaque semaine</p>
                    </div>
                </div>
            </div>
            <div class="grsection">
                <h1>La Libre parole</h1>
                <img src="@/assets/illustration/IMG-20251023-WA0005.jpg" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                        Le groupe de libre parole est un espace d’échange bienveillant où les participants peuvent s’exprimer librement sur leurs expériences, leurs émotions et leurs questionnements. À travers des discussions guidées ou spontanées, il favorise l’écoute, le partage et le soutien mutuel. Cette pratique aide à renforcer la confiance en soi, à réduire l’isolement et à créer des liens authentiques au sein du groupe.
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i>Avenue Leopold-Robert 9 / 2300 La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> Jusqu'à 15 personnes</p>
                        <p><i class="material-icons">phone</i> 076 287 33 36 </p>
                        <p><i class="material-icons">event_available</i>Chaque semaine</p>
                    </div>
                </div>
            </div>
            <div class="grsection">
                <h1>La musicothérapie</h1>
                <img src="@/assets/illustration/IMG-20251023-WA0004.jpg" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                        La musicothérapie en groupe est une approche thérapeutique qui utilise la musique pour favoriser l’expression, la communication et le bien-être des participants. À travers l’écoute musicale active, l’improvisation, le chant et l’utilisation d’instruments comme les percussions, le piano ou la guitare, elle permet de travailler sur les émotions, la relaxation et la cohésion du groupe. Nul besoin d’être musicien où initié au solfège, car l’objectif n’est pas de faire de la musique mais de voir ce que la musique vous fait. Cette pratique crée un espace d’échange bienveillant, où chacun peut s’exprimer librement et trouver du soutien à travers la musique.
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i>Avenue Leopold-Robert 9 / 2300 La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> Jusqu'à 15 personnes</p>
                        <p><i class="material-icons">phone</i> 076 287 33 36 </p>
                        <p><i class="material-icons">event_available</i>1 semaine sur 2</p>
                    </div>
                </div>
            </div>
            <div class="grsection">
                <h1>L'art-thérapie</h1>
                <img src="@/assets/illustration/IMG-20251023-WA0003.jpg" class="bot-img"  alt="Groupe de personnes qui discute">
                <div class=wrapper>
                    <div class="description">
                        <p>
                        L'art-thérapie en groupe est une approche de soin psychique qui utilise la création artistique comme moyen d’expression et de transformation. À travers des médiums variés tels que le dessin, la peinture, le collage, la danse, la voix ou l’expression théâtrale, elle permet d’explorer ses émotions, ses ressentis et ses conflits internes sans passer uniquement par la parole. Il ne s’agit pas de produire une œuvre esthétique, mais de vivre un processus créatif dans un cadre bienveillant et sécurisant. Cette pratique favorise le lâcher-prise, la connaissance de soi et le développement des ressources personnelles.
                        </p>
                    </div>
                    <div class="infos">
                        <p><i class="material-icons">place</i>Avenue Leopold-Robert 9 / 2300 La Chaux-de-Fonds </p>
                        <p><i class="material-icons">group</i> Jusqu'à 15 personnes</p>
                        <p><i class="material-icons">phone</i> 076 287 33 36 </p>
                        <p><i class="material-icons">event_available</i>Chaque semaine</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <MainFooter/>
</template>

<script>
import MainHeader from '../global/MainHeader.vue';
import MainFooter from '../global/MainFooter.vue';
import VerticalBarGrT from './parts/VerticalBarGrT.vue';

    export default {
        name: 'GrTMain',
        data() {
            return {
                //
            }
        },
        methods: {
            //
        },
        components: {
            MainHeader,
            MainFooter,
            VerticalBarGrT
        }
    }
</script>

<style scoped>
   .wrapper{
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 40px;
        min-height: 400px;
    }

    .description{
        width: max-content;
        flex-basis: 0;
        flex-grow: 1;
        text-align: justify;
    }

    .infos{
        width: max-content;
        flex-basis: 0;
        flex-grow: 1;
    }

    .content{
        background: var(--white);
        display: flex;
        flex-direction: row;
        margin-top: 50px;
        padding-bottom: 200px;
    }

    div.grsection{
        min-height: 800px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }
    div.grsection img{
        max-height: 300px;
        object-fit: contain;
    }

    
    @media only screen and (max-device-width: 600px ){

        div.content{
            overflow: hidden;
        }   
        div.grsection{
            min-height: 1200px;
            font-size: small;
           
        }
        .wrapper{
            flex-direction: column;
        }
        .description{
            width: 100%;
            gap: 0px;
        }

        h1{
            font-size: 1.2rem;
        }
        
        div.container{
            width: calc(100% - 80px);
        }

        .content{
            flex-direction: column;
            margin-top: 0px;
            padding-bottom: 0px;
        }
        
    }
</style>